import React from 'react';
import { Calendar, DollarSign, Activity, Building, FileCheck, Quote, Star } from 'lucide-react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { useTranslations } from '../hooks/useTranslations';
export function Requirements() {
  const {
    t
  } = useTranslations();
  const requirements = [{
    icon: <Calendar className="w-5 h-5" data-id="element-424" />,
    text: t('requirements.req1.title')
  }, {
    icon: <DollarSign className="w-5 h-5" data-id="element-425" />,
    text: t('requirements.req2.title')
  }, {
    icon: <Activity className="w-5 h-5" data-id="element-426" />,
    text: t('requirements.req3.title')
  }, {
    icon: <Building className="w-5 h-5" data-id="element-427" />,
    text: t('requirements.req4.title')
  }, {
    icon: <FileCheck className="w-5 h-5" data-id="element-428" />,
    text: t('requirements.req5.title')
  }];
  const testimonials = [{
    name: 'Nicole Saskia',
    role: 'Retail Store Owner',
    quote: 'I was amazed by how fast the process was. I applied in the morning and had funds in my account by the afternoon. The rates were much better than I expected.',
    stars: 5
  }, {
    name: 'Angela Ursel',
    role: 'Restaurant Owner',
    quote: 'Brixen Funding helped us expand our patio seating just in time for summer. The approval process was seamless and the team was incredibly helpful.',
    stars: 5
  }, {
    name: 'Marcus Johnson',
    role: 'Construction Firm',
    quote: 'Traditional banks turned us down because we were too new. Brixen looked at our revenue, not just our history, and got us the equipment financing we needed.',
    stars: 5
  }];
  return <section id="requirements" className="py-20 bg-gray-50" data-id="element-429">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-430">
        {/* Requirements Section */}
        <div className="mb-20" data-id="element-431">
          <div className="text-center mb-10" data-id="element-432">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-433">
              {t('requirements.title')}{' '}
              <span className="text-[#00E676]" data-id="element-434">
                {t('requirements.titleHighlight')}
              </span>
            </h2>
            <p className="text-gray-600" data-id="element-435">{t('requirements.subtitle')}</p>
          </div>

          <div className="flex flex-wrap justify-center gap-4 mb-10" data-id="element-436">
            {requirements.map((req, index) => <div key={index} className="flex items-center bg-white px-6 py-4 rounded-lg shadow-sm border border-gray-100" data-id="element-437">
                <div className="text-[#00E676] mr-3" data-id="element-438">{req.icon}</div>
                <span className="font-semibold text-gray-800" data-id="element-439">{req.text}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-440">
            <Button onClick={() => document.getElementById('contact')?.scrollIntoView()} data-id="element-441">
              {t('requirements.cta')}
            </Button>
          </div>
        </div>

        {/* Testimonials Section */}
        <div id="testimonials" data-id="element-442">
          <div className="text-center mb-12" data-id="element-443">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-444">
              Real Results from Real Business Owners
            </h2>
            <p className="text-gray-600" data-id="element-445">Don't just take our word for it.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-446">
            {testimonials.map((testimonial, index) => <Card key={index} className="relative" data-id="element-447">
                <Quote className="absolute top-6 right-6 w-8 h-8 text-green-100 fill-current" data-id="element-448" />
                <div className="flex text-[#00E676] mb-4" data-id="element-449">
                  {[...Array(testimonial.stars)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-450" />)}
                </div>
                <p className="text-gray-600 mb-6 italic relative z-10" data-id="element-451">
                  "{testimonial.quote}"
                </p>
                <div data-id="element-452">
                  <p className="font-bold text-gray-900" data-id="element-453">{testimonial.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-454">{testimonial.role}</p>
                </div>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}